<template>
  <ul :class="`curriculum len_${data_lineLen}`">
    <template v-for="(item,index) in data_list" :key="index">
      <li @click="toCourse(item.id)">
        <img :src="item.cover" alt="">
        <div class="msg">
          <h5 v-html="item.name"></h5>
          <p v-if="item.money">
            <i><template v-if="item.id != 2372 && item.id != 2449">{{numFormat_cpu(item.buys)}}人购买</template></i>
            <template v-if="item.limitTimeFree === 'T'">
              <span>限时免费</span>
            </template>
            <template v-else>
              <span>
                <del v-if="item.activity && item.activity.promotionType==='FIXED_DISCOUNT_PRICE'">￥{{item.money}}</del>
                <b>￥{{(item.activity && item.activity.promotionType==='FIXED_DISCOUNT_PRICE')?item.activity.discount:item.money}}</b>
              </span>
            </template>
          </p>
          <p v-else class="free"><i>{{numFormat_cpu(item.views)}}人观看</i><span>免费</span></p>
        </div>
        <!-- hover -->
        <div class="active">
          <h5 v-html="item.name"></h5>
          <span v-if="item.speakerNames">讲者：{{item.speakerNames?item.speakerNames:'未知'}}</span>
          <dl>
            <dd v-for="(tag,tagIndex) in item.subspecialties" :key="tagIndex" v-html="`#${tag.name}`"></dd>
            <dd v-for="(tag,tagIndex) in item.tags" :key="tagIndex" v-html="`#${tag.name}`"></dd>
          </dl>
        </div>
      </li>
    </template>
    <li class="complement" v-for="(complement,complement_index) in replenish_dom_cputd(data_list.length,data_lineLen)"
        :key="complement_index"></li>
  </ul>
</template>

<script>
  import {replenish_dom,numFormat} from '@/utils/methods.js'

  export default {
    name: "curriculum",
    // data_lineLen 每行格数 默认4 ，data_list 总个数
    props: ['data_lineLen', 'data_list'],
    computed: {
      replenish_dom_cputd() {
        return (arr, len) => {
          return replenish_dom(arr, len);
        }
      },
      numFormat_cpu() {
        return (num) => {
          return numFormat(num);
        }
      },
    },
    methods:{
      // 跳往视频详情
      toCourse(id){
        const routeLink = this.$router.resolve({
          path:  `/pages/coursePlay/coursePlay`,
          query: {
            courseId: id
          }
        })
        window.open(routeLink.href, '_blank');
      }
    },
    mounted() {
      console.log(this.replenish_dom_cputd(this.data_list.length,this.data_lineLen))
    }
  }
</script>

<style scoped lang="scss">
  /* 收费课程、讲师大全、免费课程 课程样式  */
  .curriculum {
    display: flex !important;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      @extend %defaultBg;
      display: flex;
      flex-direction: column;
      width: 226px;
      border-radius: 6px;
      overflow: hidden;
      flex: 0 0 auto;
      margin-bottom: 20px;
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 127px;
        transition: all .3s;
      }

      .msg {
        padding: 10px;
        display: flex;
        flex-direction: column;
        transition: all .3s;
        height:112px;
        flex: 0 0 auto;

        h5 {
          font-size: 16px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          flex: 0 0 auto;
          margin-bottom: 20px;
          @extend %blodFont;
        }

        p {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          margin-top: auto;

          i {
            font-size: 14px;
            color: #708AA2;
          }

          span {
            font-size: 16px;
            color: #E7732E;
            line-height: 20px;

            del{
              font-size: 14px;
              color: #aaa;
            }
            b{
              display: inline-block;
              &:first-letter {
                font-size: 12px!important;
              }
            }
          }

          &.free{
            span {
              font-size: 16px;
              color:#2EA5E7;

              /*&::first-letter {*/
              /*  font-size: 18px;*/
              /*}*/
            }
          }
        }
      }

      .active {
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        transition: all .3s;
        padding: 10px;
        display: flex;
        flex-direction: column;

        h5 {
          font-size: 16px;
          color: #fff;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          flex: 0 0 auto;
        }

        span {
          margin-top: 6px;
          font-size: 14px;
          color: #fff;
        }

        dl {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;

          dd {
            flex: 0 0 auto;
            margin-right: 6px;
            margin-bottom: 3px;
            padding: 3px 8px;
            color: #62C3FF;
            border-radius: 6px;
            background: rgba(0, 0, 0, 0.6);
            font-size: 12px;
            max-width: 100%;
          }
        }
      }

      &:hover .active {
        opacity: 1;
      }

      &:hover img, &:hover .msg {
        filter: blur(2px);
      }
    }
  }

  .complement {
    background: transparent;
    width: 0;
    height: 0;
    margin:0;
    border:none!important;
  }

  .len_4 {
    li {
      width: 286px;

      img {
        height: 162px;
      }
    }
  }

  .len_5 {
    li {
      width: calc(20% - 16px);

      img {
        width: 100%;
        aspect-ratio: 16/9;
      }
    }
  }
</style>
